import { PotionPromoType, PotionTicketBook, getTicketBookNameForTicketBookId } from '@/components/game/implementations/uk/potion/_domain/models/ticket-book';

enum PotionPrizeType {
  Jackpot = 'jackpot',
  Prize = 'prize'
}

const prizeTypeNameMap: PotionTicketBook[] = [
  PotionTicketBook.Youth,
  PotionTicketBook.Love,
  PotionTicketBook.Wisdom
];

function getPrizeTypeName(prizeType: PotionPrizeType): string {
  switch (prizeType) {
    case PotionPrizeType.Jackpot:
      return 'Jackpot';
    case PotionPrizeType.Prize:
      return 'Prize';
  }
}

function getPrizeTypeNameForLevel(prizeTypeLevel: number, promoType?: PotionPromoType): string {
  const ticketBookId = prizeTypeNameMap[prizeTypeLevel - 1];
  return getTicketBookNameForTicketBookId(ticketBookId, promoType);
}

function getPrizeTypeStage(prizeType: PotionPrizeType): number {
  switch (prizeType) {
    case PotionPrizeType.Jackpot:
      return 2;
    case PotionPrizeType.Prize:
      return 1;
  }
}

export { PotionPrizeType, getPrizeTypeNameForLevel, getPrizeTypeStage, getPrizeTypeName };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/potion/_domain/models/prize-type.ts